import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface NotificationState {
    unreadCount: number;
    showFlexTokenExpiry: boolean;
    flexTokenExpiryDays: number
}

const initialState: NotificationState = {
    unreadCount: 0,
    showFlexTokenExpiry: false,
    flexTokenExpiryDays: 0
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setUnreadCount: (state, { payload }: PayloadAction<number>) => ({
            ...state,
            unreadCount: payload,
        }),
        setShowFlexTokenExpiryInfo: (state, { payload }: PayloadAction<unknown>) => ({
            ...state,
            showFlexTokenExpiry: payload.show,
            flexTokenExpiryDays: payload.days
        }),
        setShowFlexTokenExpiry: (state, { payload }: PayloadAction<boolean>) => ({
            ...state,
            showFlexTokenExpiry: payload
        }),
    },
});

export const {
    setUnreadCount,
    setShowFlexTokenExpiryInfo,
    setShowFlexTokenExpiry
} = notificationSlice.actions;

export default notificationSlice.reducer;
